import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/home/Home';
import Navigation from './componnets/navigation/Navigation';
import Header from './componnets/header/Header';
import { useEffect, useState } from 'react';
import News from './pages/news/News';
import Login from './pages/admin/login/Login';
import Contact from './pages/contact/Contact';
import Seminar from './pages/seminar/Seminar';
import Course from './pages/course/Course';
import Footer from './componnets/footer/Footer';
import swipeup from '../src/img/swipeup.png'
import Snowfall from 'react-snowfall';
import Responsibility from './pages/responsibility/Responsibility';
import Fps from './componnets/fps/Fps';
import fpsicon from './img/fps.png'
import Competition from './pages/competition/Competition';
import gsap from 'gsap';
import { useRef } from 'react';
import Departments from './pages/departments/Departments';
import Ticket from './componnets/ticket/Ticket';
import iconticket from './img/ticket.png'
function App() {
  const [loading, setLoading] = useState(true);
  const [selectnav, setSelectnav] = useState(window.location.pathname)
  const [getscroll, setGetscroll] = useState()
  const [onlineUsers, setOnlineUsers] = useState(0);
  const [showfps, setShowfps] = useState(false);
  const [showmenu, setShowmenu] = useState(false)
  const [parts, setParts] = useState('')
  const [showticket, setShowticket] = useState(false)

  const location = useLocation();

  useEffect(() => {
    return () => setParts('');
  }, [location.pathname]);
  function showmenuoff(){
    setShowmenu(false)
  }



  const containerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.to('.line', {
        width: '100%',
        duration: 2,
        ease: 'power4.inOut'
      });
      gsap.from('.welcomtext', {
        y: -200,
        duration: 2,
        ease: 'elastic.out(1,0.3)'
      });
      gsap.to('.line', {
        height: '100%',
        top: '0%',
        delay: 2,
        backgroundColor: 'rgb(209, 203, 203)'
      })
    }, containerRef);

    return () => ctx.revert();
  }, []);


  function loadpage() {
    setTimeout(() => {
      setLoading(false)
    }, 2450)
  }
  loadpage()

  function swipingup() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  useEffect(() => {
    function handleScroll() {
      setGetscroll(window.scrollY);
    }
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(() => {
    const socket = new WebSocket('ws://185.164.73.170:4001');


    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setOnlineUsers(data.onlineUsers);
    };

    return () => {
      socket.close();
    };
  }, []);
  const [snowCount, setSnowCount] = useState(-30);

  useEffect(() => {
    const interval = setInterval(() => {
      setSnowCount((prev) => (prev < 80 ? prev + 1 : 80));
    }, 70);
    return () => clearInterval(interval);
  }, []);


  function showingfps() {
    showfps ? setShowfps(false) : setShowfps(true)
  }
  return (
    <div>
      <div className="loadingweb" ref={containerRef} style={{ display: loading ? 'flex' : 'none' }}>
        <h1 className='welcomtext'>MAHOGANY</h1>
        <div className="line"></div>
      </div>
      <div className='main' style={{ display: loading ? 'none' : 'block' }}>
        <div className='headwebsite'>
          <img className='fpsimage' src={fpsicon} onClick={showingfps} style={{ left: showfps ? '85px' : '5px' }} loading='lazy' alt='fps'></img><Fps showfps={showfps} />
          <Header showmenu={showmenu} setShowmenu={setShowmenu} onlineUsers={onlineUsers} />
          <Navigation showmenu={showmenu} setShowmenu={setShowmenu} setSelectnav={setSelectnav} selectnav={selectnav} />
        </div>
        <div className='conteiner' onClick={showmenuoff}>
          <Ticket showticket={showticket} setShowticket={setShowticket} />
          <img className='iconticket' src={iconticket} onClick={() => showticket ? setShowticket(false) : setShowticket(true)} loading='lazy' alt='ticket'></img>
          <Snowfall style={{ zIndex: '500' }} snowflakeCount={snowCount} speed={[0.5, 2]} wind={[0, 1]} />
          <Routes>
            <Route path='/' element={<Home setSelectnav={setSelectnav} loading={loading} setLoading={setLoading} />} />
            <Route path='/responsibility' element={<Responsibility />} />
            <Route path='/departments' element={<Departments />} />
            <Route path='/course' element={<Course />} />
            <Route path='/seminar' element={<Seminar parts={parts} setParts={setParts} />} />
            <Route path='/competition' element={<Competition parts={parts} setParts={setParts} />} />
            <Route path='/news' element={<News />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/admin' element={<Login />} />
          </Routes>
          <Footer />
        </div>
        <div className='swipeup' onClick={swipingup}><img style={{ display: getscroll > 0 ? 'block' : 'none' }} src={swipeup} loading='lazy' alt='swipeup'></img></div>
      </div>
    </div>
  );
}

export default App;
